import * as React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { useTheme } from '@mui/material';

export default function GlobalCssOverride() {
  const theme = useTheme();
  return (
    <GlobalStyles
      styles={{
        body: {
          margin: 0,
          overflow: 'hidden',
          '#watermark': {
            display: 'none!important', // smart-webcomponents-react/scheduler
          },
        },
        '*::-webkit-scrollbar-track': {
          border: `1px solid ${theme.palette.background.default}`,
          backgroundColor: theme.palette.background.default,
        },
        '*::-webkit-scrollbar': {
          width: '0.3125rem',
          backgroundColor: theme.palette.background.paper,
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.grey[400],
          borderRadius: '4px',
        },
        'input:-webkit-autofill, input:-webkit-autofill:focus, input:-internal-autofill-selected, input:-internal-autofill-selected:focus':
          {
            transition: 'background-color 600000s 0s, color 600000s 0s',
          },
        '.MuiTableHead-root': {
          backgroundColor: 'grey.200',
        },
      }}
    />
  );
}
